<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.addonStart) {
    <span
      class="input-group-text"
      [ngClass]="props.addonStartClass"
      >
      {{ props.addonStart }}
    </span>
  }

  <input
    [type]="props.inputType ?? 'text'"
    class="form-control form-control-lg"
    [formControl]="formControl"
    [placeholder]="props.placeholder"
    [formlyAttributes]="field"
    [attr.data-testid]="field.key"
    [class.is-invalid]="invalid"
    [class.is-valid]="valid"
    [attr.aria-describedby]="errorId + ' ' + errorDescriptionId"
    />

  @if (props.addonEnd) {
    <span
      class="input-group-text"
      [ngClass]="props.addonEndClass"
      >
      {{ props.addonEnd }}
    </span>
  }

  @if (props.addonEndButton) {
    <button
      class="btn btn-2022--secondary"
      type="button"
      (click)="props.addonEndButton.clickAction()"
      >
      {{ props.addonEndButton.text }}
    </button>
  }
</div>

@if (showError && !props.suppressErrors) {
  <div class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
    <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
    <formly-validation-message class="ms-3" [id]="id + '-error-description-id'" [field]="field"></formly-validation-message>
  </div>
}
